<div *ngIf="isAlert12hour" class="warning-alert-notification-style">
    <mat-icon mat-dialog-close (click)="toggleChange()" class="mat-dialog-close">close</mat-icon>
    At least one of the shifts selected is within <strong>12 hours</strong> and is considered a <strong>late staffing request</strong>. It will be billed at a higher rate with a processing fee of <strong>15%</strong>.
</div>